"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AptosProvider = void 0;
const protocol_1 = require("../../protocol");
const utils_1 = require("../../utils");
const InjectUtils_1 = require("../InjectUtils");
const media_1 = require("../../utils/media");
const localforage_1 = require("localforage");
const aptosChainList = Object.freeze([
    "637",
    "70000060",
    "70000066",
]);
const aptosInjectChainMap = new Map();
aptosInjectChainMap.set("aptos:637", "Mainnet");
aptosInjectChainMap.set("aptos:70000060", "Movement Testnet");
aptosInjectChainMap.set("aptos:70000066", "Movement Mainnet");
class AptosProvider {
    send(request) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                (0, utils_1.logDebug)("AptosProvider send request:", (0, utils_1.safeJsonStringify)(request));
                yield this.restoreConnect();
                let network = yield window.okxwallet.aptos.network();
                let searchNetwork = this.searchChainIdToInjectChainName(request.chainId);
                (0, utils_1.logDebug)("AptosProvider send network and searchNetwork:", network, "-----", searchNetwork);
                if (!(network && searchNetwork && network.toLowerCase() === searchNetwork.toLowerCase())) {
                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `Please switch your wallet link to '${searchNetwork}'`);
                }
                const method = request.method;
                let result;
                switch (method) {
                    case "aptos_signMessage":
                        {
                            if (request.injectParams) {
                                let message = yield window.okxwallet.aptos.signMessage(request.injectParams);
                                result = {
                                    method: request.method,
                                    result: message.signature,
                                    injectResult: message
                                };
                                (0, utils_1.logDebug)("AptosProvider send result:", (0, utils_1.safeJsonStringify)(result));
                                return result;
                            }
                            else {
                                throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR, `param is error method: '${method}'`);
                            }
                        }
                        break;
                    case "aptos_signTransaction":
                        {
                            (0, utils_1.logDebug)("AptosProvider Method>>>> :", method);
                            let message = yield window.okxwallet.aptos.signTransaction(request.params);
                            result = {
                                method: request.method,
                                result: message,
                            };
                            (0, utils_1.logDebug)("AptosProvider send result:", (0, utils_1.safeJsonStringify)(result));
                            return result;
                        }
                        break;
                    case "aptos_signAndSubmitTransaction":
                        {
                            (0, utils_1.logDebug)("AptosProvider Method>>>> :", method);
                            let message = yield window.okxwallet.aptos.signAndSubmitTransaction(request.params);
                            result = {
                                method: request.method,
                                result: message.hash,
                            };
                            (0, utils_1.logDebug)("AptosProvider send result:", (0, utils_1.safeJsonStringify)(result));
                            return result;
                        }
                        break;
                    default:
                        throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.METHOD_NOT_SUPPORTED, ` method: '${method}'`);
                }
            }
            catch (error) {
                (0, utils_1.logDebug)("AptosProvider send error:", error);
                throw error;
            }
        });
    }
    searchChainIdToInjectChainName(chainId) {
        let chainName = chainId;
        aptosInjectChainMap.forEach((value, key) => {
            if (chainId.includes(key)) {
                chainName = value;
            }
        });
        return chainName;
    }
    disconnect() {
    }
    restoreConnect() {
        if ((0, media_1.isDevice)("mobile")) {
            return this.connect();
        }
        return Promise.resolve();
    }
    parseConnectResponse(needPop, accountChange, signalChain, connectWalletNameSpace, connectRequestWalletResponse, dappInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            let connectChain = [];
            connectWalletNameSpace.forEach(item => {
                if (item.namespace === protocol_1.NameSpaceKeyAptos) {
                    connectChain.push(...item.chains);
                }
            });
            let addresses = [];
            let extra = {};
            (0, utils_1.logDebug)("AptosProvider parseConnectResponse connectChain", JSON.stringify(connectChain));
            let publicKey = undefined;
            if (!(0, media_1.isDevice)('mobile') && connectChain && connectChain.length > 0) {
                let aptosAccount = yield window.okxwallet.aptos.connect();
                publicKey = aptosAccount.publicKey;
            }
            connectChain.forEach((chainStr) => {
                let selectedAddress = connectRequestWalletResponse.address.find((addressItem) => {
                    return (aptosChainList.includes(addressItem.chainId) && addressItem.coinType === 637) || (addressItem.namespaceChainId === chainStr);
                });
                if (selectedAddress) {
                    addresses.push(chainStr + ":" + selectedAddress.address);
                    extra[chainStr] = {
                        publicKey: selectedAddress.publicKey ? selectedAddress.publicKey : publicKey
                    };
                }
            });
            (0, utils_1.logDebug)("AptosProvider parseConnectResponse addresses", JSON.stringify(addresses));
            if (addresses && addresses.length > 0) {
                let nameSpaceResponse = {
                    namespace: protocol_1.NameSpaceKeyAptos,
                    addresses: addresses,
                    methods: [...InjectUtils_1.AptosMethods],
                    extra: extra
                };
                return nameSpaceResponse;
            }
            return undefined;
        });
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            return window.okxwallet.aptos.connect();
        });
    }
    singleConnect() {
        return this.connect();
    }
    addAccountChangedListener(accountChangeListener) {
        window.okxwallet.aptos.onAccountChange((newAccount) => {
            console.log("window.okxwallet configEventWithKey_aptos:", Date.now(), localforage_1.key, JSON.stringify(newAccount));
            if (newAccount) {
                accountChangeListener();
            }
        });
    }
    removeListener() {
    }
}
exports.AptosProvider = AptosProvider;
